export const appConfig = {
  enableCMP: true,
  /** Google Tag Manager container ID (e.g. "GTM-XXXXXX") – GA4 läuft über GTM */
  gtmId: "GTM-TJN89LTW",
  /** Smooth scroll via Lenis – bei false wird natives Browser-Scrolling verwendet */
  smoothScroll: false,
};